import { AccessibilityHiddenImg } from '@skillz/accessibility';
import { useSelector } from 'react-redux';
import waitNavigatePageGif from '../../assests/waitNavigatePageGif.gif';
import classes from './NavigateGif.module.css';

const NavigateGif = () => {

    const { texts } = useSelector(state => state.translate);

    return (
        <div className={classes.NavigateGif}>
            <AccessibilityHiddenImg src={waitNavigatePageGif} />
            <div className={classes.Text}>{texts.delayNavigatePageText}</div>
        </div>
    )
}
export default NavigateGif;